module.exports = __webpack_public_path__ + "img/img4.fabee9e3.jpg";